"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _DocumentGroup = require("./DocumentGroup");
Object.keys(_DocumentGroup).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DocumentGroup[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DocumentGroup[key];
    }
  });
});